import React, { useState, useEffect } from "react";
import KuyumcuLeftSideNavbar from "./components/KuyumcuLeftSideNavbar";
// import PremiumBackground from "./components/PremiumBackground";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Chip,
  CircularProgress,
  Alert,
  IconButton,
} from "@mui/material";

import {
  FaUser,
  FaUsers,
} from "react-icons/fa";

import { Edit, Delete } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";

import "./css/KuyumcuMainPage.css";
import "./css/KuyumcuHesaplarPage.css";

import ProsetDataGrid from "./components/KuyumcuDataGrid";
import ProsetPopup from "./components/ProsetPopup";
import SilmeUyariPopup from "./components/SilmeUyariPopup";
import ProsetGrid from "./components/ProsetSimpleGrid";

import { getUserId } from "../../utils/getUserId";
import { usePermission } from "../../context/PermissionContext";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

/* ==========================================================
   SABİTLER
========================================================== */
const grupKodlari = [
  { id: 1, label: "MÜŞTERİ" },
  { id: 2, label: "ATÖLYE" },
  { id: 3, label: "ÇANTA" },
  { id: 4, label: "ORTAK" },
  { id: 5, label: "EMANET" },
  { id: 6, label: "BANKA" },
  { id: 7, label: "PERSONEL" },
  { id: 8, label: "ARŞİV" },
  { id: 9, label: "MASRAF" },
];

const bakiyeFiltreleri = ["Tümü", "Bakiyeli", "Borçlu (Gr)", "Alacaklı (Gr)"];

/* ==========================================================
   1) BAKİYE FORMATLAYICI
========================================================== */
const formatBakiye = (value) => {
  if (value == null || value === "") return "0";
  const num = Number(value);
  if (isNaN(num)) return "0";
  return num.toFixed(3).replace(/\.?0+$/, "");
};

/* ==========================================================
   2) RENKLİ BAKİYE GÖSTERİMİ
========================================================== */
const renderBakiyeColored = (value) => {
  const formatted = formatBakiye(value);
  const num = Number(value);

  let color = "#555";
  if (num > 0) color = "#2ecc71";
  if (num < 0) color = "#e74c3c";

  return (
    <span
      style={{
        color,
        fontWeight: "600",
        fontSize: "0.95rem",
      }}
    >
      {formatted}
    </span>
  );
};

/* ==========================================================
   ANA COMPONENT
========================================================== */
const KuyumcuHesaplarPage = () => {
  const navigate = useNavigate();
  const { can, isLoading } = usePermission();

    // ====== SAYFA İÇİ YETKİ KODLARI (DB’NDEKİ KODLARLA EŞLEŞTİR) ======
    const PERM_HESAP_CREATE = "HESAPLAR_CREATE";
    const PERM_HESAP_UPDATE = "HESAPLAR_UPDATE";
    const PERM_HESAP_DELETE = "HESAPLAR_DELETE";
    const PERM_HESAP_DETAY_VIEW = "HESAP_ISLEMLER_VIEW"; // detay sayfasına gidebilmek için


  const userId = getUserId();
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token");

  // LOGIN KONTROL
  useEffect(() => {
    if (!userId || !token) {
      navigate("/login");
    }
  }, [userId, token, navigate]);

  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [silmePopupOpen, setSilmePopupOpen] = useState(false);
  const [silinecekId, setSilinecekId] = useState(null);
  const [silmeMesaji, setSilmeMesaji] = useState(
    "Bu hesabı silmek istediğinize emin misiniz?"
  );


  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Bölge Kod dropdown datası
  const [bolgeKodList, setBolgeKodList] = useState([]);

  useEffect(() => {
    console.log("ROWLAR:", rows);
  }, [rows]);

  const [searchText, setSearchText] = useState("");
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const [selectedGroups, setSelectedGroups] = useState([]);
  const [bakiyeFilter, setBakiyeFilter] = useState("Tümü");

  const [form, setForm] = useState({
    hesapAdi: "",
    telefon: "",
    bolgeKodId: "",
    bolgeKod: "",
    grupKod: "",
    ozelKod: "",
    id: null,
  });

  const [formErrors, setFormErrors] = useState({});

  /* ==========================================================
      EKRAN BOYUTU TAKİBİ
  =========================================================== */
  useEffect(() => {
    const onResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const hasAnyBakiye = (row) => {
    const values = [
      row.gramBakiye,
      row.tlBakiye,
      row.usdBakiye,
      row.eurBakiye,
      row.yeniAta,
      row.yeniYarim,
      row.yeniCeyrek,
      row.eskiAta,
      row.eskiYarim,
      row.eskiCeyrek,
    ];

    return values.some((v) => Number(v) !== 0);
  };


  /* ==========================================================
      VERİ ÇEK
  =========================================================== */

  /* ==========================================================
      BÖLGE KOD LİSTESİ ÇEK (dropdown)
  ========================================================== */
  const fetchBolgeKodList = async () => {
    try {
      if (!userId) return;

      const resp = await axiosInstance.get("/parametreler/bolge-kod");


      setBolgeKodList(resp.data || []);
    } catch (e) {
      setBolgeKodList([]);
    }
  };


  const fetchAccounts = async () => {
    try {
      setLoading(true);

      if (!userId) return;

      const resp = await axiosInstance.get(`/hesaplar`);

    const mapped = resp.data.map((d) => {

      return {
        id: d.id,
        ad: d.hesapAdi,
        telefon: d.telefon,
        grup: d.grupKod,
        grupLabel: grupKodlari.find((g) => g.id === d.grupKod)?.label || "",
        bolge: d.bolgeKod,
        bolgeKodId: d.bolgeKodId,
        ozel: d.ozelKod,

        gramBakiye: Number(d.gramBakiye || 0),
        tlBakiye: Number(d.tlBakiye || 0),
        usdBakiye: Number(d.usdBakiye || 0),
        eurBakiye: Number(d.eurBakiye || 0),

        yeniAta: parseInt(d.yeniAta || 0),
        yeniYarim: parseInt(d.yeniYarim || 0),
        yeniCeyrek: parseInt(d.yeniCeyrek || 0),
        eskiAta: parseInt(d.eskiAta || 0),
        eskiYarim: parseInt(d.eskiYarim || 0),
        eskiCeyrek: parseInt(d.eskiCeyrek || 0),

      };
    });

      setRows(mapped);
    } catch (err) {
      setError("Hesaplar yüklenirken hata oluştu.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchAccounts();
      fetchBolgeKodList(); // YENİ
    }
  }, [userId]);

  /* ==========================================================
      FORM VALIDATION
  =========================================================== */
  const validateForm = () => {
    let errors = {};

    if (!form.hesapAdi) errors.hesapAdi = "Hesap Adı zorunludur.";
    if (!form.grupKod) errors.grupKod = "Grup Kod zorunludur.";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  /* ==========================================================
      SAVE
  =========================================================== */
  const handleSave = async () => {
    if (!validateForm()) return;

//     const needPerm = editMode ? PERM_HESAP_UPDATE : PERM_HESAP_CREATE;
//     if (isLoading || !can(needPerm)) {
//       alert("Bu işlem için yetkiniz yok.");
//       return;
//     }

    try {
      if (editMode) {
        await axiosInstance.put("/hesaplar", {
          id: form.id,
          hesapAdi: form.hesapAdi,
          telefon: form.telefon,
          bolgeKodId: form.bolgeKodId ? Number(form.bolgeKodId) : null,
          grupKod: Number(form.grupKod),
          ozelKod: form.ozelKod,
        });
      } else {
        await axiosInstance.post("/hesaplar", {
          hesapAdi: form.hesapAdi,
          telefon: form.telefon,
          bolgeKodId: form.bolgeKodId ? Number(form.bolgeKodId) : null,
          grupKod: Number(form.grupKod),
          ozelKod: form.ozelKod,
        });
      }

      setOpen(false);
      setEditMode(false);
      fetchAccounts();

      setForm({
        hesapAdi: "",
        telefon: "",
        bolgeKodId: "",
        bolgeKod: "",
        grupKod: "",
        ozelKod: "",
        id: null,
      });
    } catch {
      alert("Kayıt sırasında hata oluştu.");
    }
  };

  /* ==========================================================
      DELETE
  =========================================================== */
  const handleDeleteConfirmed = async () => {
    const row = rows.find((r) => r.id === silinecekId);

    if (row && hasAnyBakiye(row)) {
      alert("Bakiyesi bulunan hesaplar silinemez.");
      setSilmePopupOpen(false);
      return; //  BACKEND ÇAĞRISI YOK
    }

    try {
      await axiosInstance.delete(`/hesaplar/${silinecekId}`);
      fetchAccounts();
    } catch {
      alert("Silme sırasında hata oluştu.");
    } finally {
      setSilmePopupOpen(false);
      setSilinecekId(null);
      setOpen(false);
    }
  };



  /* ==========================================================
      BUTONLAR
  =========================================================== */
  const actionButtons = (params) => (
    <div style={{ display: "flex", gap: "8px" }}>
      <IconButton
        style={{ color: "#b8860b" }}
        onClick={(e) => {
          e.stopPropagation();
          setEditMode(true);
          setOpen(true);
          setForm({
            id: params.row.id,
            hesapAdi: params.row.ad,
            telefon: params.row.telefon,
            bolgeKodId: params.row.bolgeKodId || "",
            grupKod: params.row.grup,
            ozelKod: params.row.ozel,
          });
        }}
      >
        <Edit />
      </IconButton>

      <IconButton
        style={{ color: "#d32f2f" }}
        onClick={(e) => {
          e.stopPropagation();
          setSilinecekId(params.row.id);
          setSilmePopupOpen(true);
        }}
      >
        <Delete />
      </IconButton>
    </div>
  );

  /* ==========================================================
      FİLTRELENMİŞ VERİ
  =========================================================== */
  const filteredRows = rows.filter((r) => {
    let matchBakiye = true;

    if (bakiyeFilter === "Bakiyeli") {
      // herhangi bir bakiye varsa
      matchBakiye = hasAnyBakiye(r);
    }

    else if (bakiyeFilter === "Borçlu (Gr)") {
      // SADECE GRAM > 0
      matchBakiye = Number(r.gramBakiye) > 0;
    }

    else if (bakiyeFilter === "Alacaklı (Gr)") {
      // SADECE GRAM < 0
      matchBakiye = Number(r.gramBakiye) < 0;
    }

    const matchSearch = r.ad.toLowerCase().includes(searchText.toLowerCase());
    const matchGroup =
      selectedGroups.length === 0 || selectedGroups.includes(r.grup);

    return matchSearch && matchGroup && matchBakiye;
  });

    const formatBakiyePretty = (value) => {
      const num = Number(value || 0);
      return num
        .toFixed(2)               // 2 hane
        .replace(".", ",")        // ondalık ayracı değiştir
        .replace(/\B(?=(\d{3})+(?!\d))/g, "."); // binlik nokta
    };

    const ziynetMap = {
      "Yeni ATA":   { short: "Y. ATA" },
      "Yeni YARIM": { short: "Y. YAR" },
      "Yeni ÇEYREK":{ short: "Y. ÇEY" },
      "Eski ATA":   { short: "E. ATA" },
      "Eski YARIM": { short: "E. YAR" },
      "Eski ÇEYREK":{ short: "E. ÇEY" },
    };

    const bakiyeEmojiMap = {
      GR: " 🪙",
      TL: " 💷",
      USD: " 💵",
      EUR: " 💶",
    };


    // --- BAKİYE HÜCRESİNİ RENDER EDEN TEK FONKSİYON ---
    const renderBakiyeCell = (row) => {
      const items = [
        ["GR", row.gramBakiye],
        ["TL", row.tlBakiye],
        ["USD", row.usdBakiye],
        ["EUR", row.eurBakiye],

        ["Yeni ATA", row.yeniAta],
        ["Yeni YARIM", row.yeniYarim],
        ["Yeni ÇEYREK", row.yeniCeyrek],
        ["Eski ATA", row.eskiAta],
        ["Eski YARIM", row.eskiYarim],
        ["Eski ÇEYREK", row.eskiCeyrek],
      ].filter(([, v]) => Number(v) !== 0);

      if (items.length === 0) return "-";

      return (
        <div className="bakiye-wrapper">
          {items.map(([label, val]) => {
            const isZiynet = !!ziynetMap[label];
            const shownLabel = isZiynet ? ziynetMap[label].short : label;

            return (
              <div className="bakiye-item" key={label}>
                <span className="bakiye-label">
                  {shownLabel}
                  {bakiyeEmojiMap[shownLabel] && (
                    <span className="bakiye-emoji">
                     {bakiyeEmojiMap[shownLabel]}:
                    </span>
                  )}

              {!bakiyeEmojiMap[shownLabel] && (
               <span className="bakiye-emoji">
                :
                </span>
              )}

                </span>

                <span className="bakiye-value">
                  {isZiynet
                    ? Math.round(Number(val) || 0)
                    : formatBakiyePretty(val)}
                </span>
              </div>
            );
          })}
        </div>
      );
    };

    const renderActions = (row) => {

      const bakiyeli = hasAnyBakiye(row);

      const canUpdate = !isLoading && can(PERM_HESAP_UPDATE);
      const canDelete = !isLoading && can(PERM_HESAP_DELETE);

      // Hiç aksiyon yetkisi yoksa boş dön (kolon boş kalsın)
      if (!canUpdate && !canDelete) return null;


      return (
        <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-start",   // ✅ dikey ortalama yerine üstten hizala
                gap: "6px",
                width: "100%",
                paddingRight: "4px",
                paddingTop: "6px",          // ✅ bakiye listesiyle aynı hizada başlasın
              }}
            >
          {canUpdate && (
            <IconButton
              style={{ color: "#b8860b" }}
              onClick={(e) => {
                e.stopPropagation();
                setEditMode(true);
                setOpen(true);
                setForm({
                  id: row.id,
                  hesapAdi: row.ad,
                  telefon: row.telefon,
                  bolgeKodId: row.bolgeKodId || "",
                  bolgeKod: row.bolge,
                  grupKod: row.grup,
                  ozelKod: row.ozel,
                });
              }}
            >
              <Edit />
            </IconButton>
          )}


        {canDelete && (
          <IconButton
            disabled={bakiyeli}   // bakiyeli ise kilit yine devam
            title={
              bakiyeli
                ? "Bakiyesi bulunan hesap silinemez"
                : "Hesabı sil"
            }
            style={{
              color: bakiyeli ? "#aaa" : "#d32f2f",
            }}
            onClick={(e) => {
              e.stopPropagation();

              if (bakiyeli) {
                setSilmeMesaji(
                  "Bakiyesi bulunan hesaplar silinemez. Önce bakiyeyi sıfırlayın."
                );
                setSilmePopupOpen(true);
                return;
              }

              setSilinecekId(row.id);
              setSilmePopupOpen(true);
            }}
          >
            <Delete />
          </IconButton>
        )}

        </div>
      );
    };




// Mobilde hesap adını kısalt
   const truncateHesapAdi = (text, max = 12) => {
      if (!text) return "";
      return text.length > max ? text.substring(0, max) + "..." : text;
    };

    let columns = [];

    /* ========== 📱 MOBİL (600px altı) ========== */
    if (screenWidth < 600) {
      columns = [
        {
          field: "ad",
          headerName: "Hesap Adı",
          flex: 1,
          render: (row) => truncateHesapAdi(row.ad, 15),
        },
        {
          field: "bakiyeDetay",
          headerName: "Bakiye",
          flex: 2,
          render: renderBakiyeCell,
        },
        {
          field: "actions",
          headerName: "",
          flex: 0.5,
          render: renderActions,
          sortable: false,
          filterable: false,
        }

      ];
    }

    /* ========== 🖥️ TABLET (600–992px arası) ========== */
    else if (screenWidth < 992) {
      columns = [
        { field: "ad", headerName: "Hesap Adı", flex: 1 },
        { field: "grupLabel", headerName: "Grup", flex: 1 },

        {
          field: "bakiyeDetay",
          headerName: "Bakiye",
          flex: 1.80,
          render: renderBakiyeCell,
        },

        {
          field: "actions",
          headerName: "",
          flex: 0.7,
          render: renderActions,
          sortable: false,
          filterable: false,
        }

      ];
    }

    else if (screenWidth < 1200) {
      columns = [
        { field: "ad", headerName: "Hesap Adı", flex: 1 },
        { field: "telefon", headerName: "Telefon", flex: 1 }, // PC’de göster
        { field: "grupLabel", headerName: "Grup", flex: 0.7 },
        { field: "bolge", headerName: "Bölge", flex: 0.5 },
        { field: "ozel", headerName: "Özel Kod", flex: 0.3 },

        {
          field: "bakiyeDetay",
          headerName: "Bakiye",
          flex: 1.5,
          render: renderBakiyeCell
        },

        {
          field: "actions",
          headerName: "",
          flex: 0.5,
          render: renderActions,
          sortable: false,
          filterable: false,
        }

      ];
    }

    /* ========== 🖥️ PC + GENİŞ EKRAN ========== */
    else {
      columns = [
        { field: "ad", headerName: "Hesap Adı", flex: 1.5 },
        { field: "telefon", headerName: "Telefon", flex: 1 }, // PC’de göster
        { field: "grupLabel", headerName: "Grup", flex: 0.7 },
        { field: "bolge", headerName: "Bölge", flex: 0.5 },
        { field: "ozel", headerName: "Özel Kod", flex: 0.5 },

        {
          field: "bakiyeDetay",
          headerName: "Bakiye",
          flex: 1.8,
          render: renderBakiyeCell
        },

        {
          field: "actions",
          headerName: "",
          flex: 0.5,
          render: renderActions,
          sortable: false,
          filterable: false,
        }

      ];
    }

    const selectedRow = rows.find((r) => r.id === form.id);
    const bakiyeliHesap = selectedRow ? hasAnyBakiye(selectedRow) : false;

  /* ==========================================================
      UI
  =========================================================== */
  return (
    <div className="main-container">
{/*     <PremiumBackground /> */}
      <KuyumcuLeftSideNavbar />

      <div className="content hesaplar-premium-bg">
        <div className="premium-waves">
          <svg className="wave wave1" viewBox="0 0 1000 700" preserveAspectRatio="none">
            <defs>
              <linearGradient id="goldGradient1" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="rgba(212,175,55,0.00)" />
                <stop offset="35%" stopColor="rgba(212,175,55,0.22)" />
                <stop offset="50%" stopColor="rgba(255,245,200,0.95)" />
                <stop offset="65%" stopColor="rgba(212,175,55,0.22)" />
                <stop offset="100%" stopColor="rgba(212,175,55,0.00)" />
              </linearGradient>
            </defs>

            <path
              className="wave-glow"
              d="M0 340 C180 210 310 470 500 320 S820 180 1000 320"
            />
            <path
              className="wave-line"
              d="M0 340 C180 210 310 470 500 320 S820 180 1000 320"
            />
            <path
              className="wave-shine"
              d="M0 340 C180 210 310 470 500 320 S820 180 1000 320"
              stroke="url(#goldGradient1)"
            />
          </svg>

          <svg className="wave wave2" viewBox="0 0 1000 700" preserveAspectRatio="none">
            <defs>
              <linearGradient id="goldGradient2" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="rgba(212,175,55,0.00)" />
                <stop offset="38%" stopColor="rgba(212,175,55,0.18)" />
                <stop offset="50%" stopColor="rgba(255,248,210,0.90)" />
                <stop offset="62%" stopColor="rgba(212,175,55,0.18)" />
                <stop offset="100%" stopColor="rgba(212,175,55,0.00)" />
              </linearGradient>
            </defs>

            <path
              className="wave-glow"
              d="M0 260 C200 420 360 120 610 270 S860 420 1000 260"
            />
            <path
              className="wave-line"
              d="M0 260 C200 420 360 120 610 270 S860 420 1000 260"
            />
            <path
              className="wave-shine"
              d="M0 260 C200 420 360 120 610 270 S860 420 1000 260"
              stroke="url(#goldGradient2)"
            />
          </svg>

          <svg className="wave wave3" viewBox="0 0 1000 700" preserveAspectRatio="none">
            <defs>
              <linearGradient id="goldGradient3" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="rgba(212,175,55,0.00)" />
                <stop offset="40%" stopColor="rgba(212,175,55,0.14)" />
                <stop offset="50%" stopColor="rgba(255,250,225,0.82)" />
                <stop offset="60%" stopColor="rgba(212,175,55,0.14)" />
                <stop offset="100%" stopColor="rgba(212,175,55,0.00)" />
              </linearGradient>
            </defs>

            <path
              className="wave-glow"
              d="M0 420 C150 300 340 520 560 390 S840 270 1000 430"
            />
            <path
              className="wave-line"
              d="M0 420 C150 300 340 520 560 390 S840 270 1000 430"
            />
            <path
              className="wave-shine"
              d="M0 420 C150 300 340 520 560 390 S840 270 1000 430"
              stroke="url(#goldGradient3)"
            />
          </svg>
        </div>

        <div className="content-inside">

        <h1 style={{ color: "#b8860b", marginBottom: 20 }}><FaUsers /> Hesaplar</h1>

        {/* HESAP AÇ */}
        {!isLoading && can(PERM_HESAP_CREATE) && (
          <Button
            startIcon={<AddCircleOutlineIcon />}
            variant="contained"
            sx={{
              background: "#b8860b",
              "&:hover": { background: "#d4a017" },
              borderRadius: "10px",
              paddingX: 3,
              mb: 2,
            }}
            onClick={() => {
              setEditMode(false);
              setForm({
                hesapAdi: "",
                telefon: "",
                bolgeKodId: "",
                bolgeKod: "",
                grupKod: "",
                ozelKod: "",
                id: null,
              });
              setFormErrors({});
              setOpen(true);
            }}
          >
            Hesap Ekle
          </Button>
        )}


        {/* GRUP FİLTRELERİ */}
        <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
          <Chip
            label="Tümü"
            onClick={() => setSelectedGroups([])}
            sx={{
              background:
                selectedGroups.length === 0
                  ? "rgba(184,134,11,0.25)"
                  : "rgba(255,255,255,0.4)",
              border:
                selectedGroups.length === 0
                  ? "2px solid #b8860b"
                  : "1px solid #ccc",
            }}
          />

          {grupKodlari.map((g) => (
            <Chip
              key={g.id}
              label={g.label}
              onClick={() =>
                setSelectedGroups((prev) =>
                  prev.includes(g.id)
                    ? prev.filter((x) => x !== g.id)
                    : [...prev, g.id]
                )
              }
              sx={{
                background: selectedGroups.includes(g.id)
                  ? "rgba(184,134,11,0.25)"
                  : "rgba(255,255,255,0.4)",
                border: selectedGroups.includes(g.id)
                  ? "2px solid #b8860b"
                  : "1px solid #ccc",
              }}
            />
          ))}
        </Box>

        {/* ARAMA */}
        <TextField
          fullWidth
          placeholder="Hesap Adı Ara..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          sx={{
            mb: 2,
            background: "rgba(255,255,255,0.45)",
            borderRadius: "12px",
          }}
        />

        {/* DATA GRID + FOOTER */}
        {loading ? (
          <Box textAlign="center" mt={3}>
            <CircularProgress color="warning" />
          </Box>
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <>
            {screenWidth < 600 ? (
              <div className="hesaplar-mobile-list">
                {filteredRows.map((row) => (
                  <div
                    key={row.id}
                    className="hesaplar-mobile-row"
                    onClick={() => {
                      navigate(`/kuyumcuSecilenHesap/${row.id}`);
                    }}
                  >
                    {/* sağ üst grup badge */}
                    <div className="hesaplar-mobile-group-badge">
                      {row.grupLabel || "-"}
                    </div>

                    {/* 1) Hesap Adı */}
                    <div className="hesaplar-mobile-name">
                      {(row.ad || "").length > 12 ? (row.ad || "").slice(0, 12) + "..." : row.ad}
                    </div>

                    {/* 2) Bakiye */}
                    <div className="hesaplar-mobile-bakiye">
                      {renderBakiyeCell(row)}
                    </div>

                    {/* 3) Aksiyonlar */}
                    <div
                      className="hesaplar-mobile-actions"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {renderActions(row)}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <>
                <ProsetGrid
                  columns={columns}
                  rows={filteredRows}
                  onRowClick={(row) => navigate(`/kuyumcuSecilenHesap/${row.id}`)}
                  onEdit={(row) => {
                    setEditMode(true);
                    setOpen(true);
                    setForm({
                      id: row.id,
                      hesapAdi: row.ad,
                      telefon: row.telefon,
                      bolgeKodId: row.bolgeKodId || "",
                      bolgeKod: row.bolge,
                      grupKod: row.grup,
                      ozelKod: row.ozel,
                    });
                  }}
                  onDelete={(row) => {
                    setSilinecekId(row.id);
                    setSilmePopupOpen(true);
                  }}
                />
              </>
            )}


            {/* BAKİYE FİLTRESİ FOOTER */}
            <Box
              display="flex"
              justifyContent="space-evenly"
              flexWrap="wrap"
              gap={2}
              mt={2}
              p={2}
              sx={{
                borderRadius: "16px",
                background: "rgba(255,255,255,0.35)",
                backdropFilter: "blur(8px)",
                border: "1px solid rgba(255,255,255,0.25)",
              }}
            >
              {bakiyeFiltreleri.map((item) => (
                <Box
                  key={item}
                  display="flex"
                  alignItems="center"
                  sx={{
                    cursor: "pointer",
                    minWidth: "120px",
                    justifyContent: "center",
                  }}
                  onClick={() => setBakiyeFilter(item)}
                >
                  <div
                    style={{
                      width: 16,
                      height: 16,
                      borderRadius: "50%",
                      border: "2px solid #b8860b",
                      marginRight: 8,
                      backgroundColor:
                        bakiyeFilter === item ? "#b8860b" : "transparent",
                      transition: "0.2s",
                    }}
                  />

                  <span
                    style={{
                      color: bakiyeFilter === item ? "#b8860b" : "#444",
                      fontWeight: bakiyeFilter === item ? "bold" : "normal",
                    }}
                  >
                    {item}
                  </span>
                </Box>
              ))}
            </Box>
          </>
        )}
      </div>

      </div>

      {/* POPUP */}
      <ProsetPopup
        open={open}
        editMode={editMode}
        title={editMode ? "Hesap Düzenle" : "Hesap Aç"}
        onSave={handleSave}
        onCancel={() => setOpen(false)}
        onDelete={() => {
            if (bakiyeliHesap) return; // hiçbir şey yapma
            setSilinecekId(form.id);
            setSilmePopupOpen(true);
          }}
          deleteDisabled={bakiyeliHesap}

      >
{/*       <PremiumBackground /> */}

        <TextField
          label="Hesap Adı"
          fullWidth
          value={form.hesapAdi}
          error={!!formErrors.hesapAdi}
          helperText={formErrors.hesapAdi}
          onChange={(e) => setForm({ ...form, hesapAdi: e.target.value })}
        />

        <TextField
          label="Telefon"
          fullWidth
          value={form.telefon}
          onChange={(e) => setForm({ ...form, telefon: e.target.value })}
        />

        <TextField
          select
          fullWidth
          label="Grup Kod"
          value={form.grupKod}
          error={!!formErrors.grupKod}
          helperText={formErrors.grupKod}
          onChange={(e) =>
            setForm({ ...form, grupKod: Number(e.target.value) })
          }
        >
          {grupKodlari.map((g) => (
            <MenuItem key={g.id} value={g.id}>
              {g.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          fullWidth
          label="Bölge Kod"
          value={form.bolgeKodId || ""}
          onChange={(e) =>
            setForm({ ...form, bolgeKodId: e.target.value ? Number(e.target.value) : "" })
          }
        >
          <MenuItem value="">Seçiniz</MenuItem>

          {bolgeKodList.map((bk) => (
            <MenuItem key={bk.id} value={bk.id}>
              {bk.bolgeKod}{bk.aciklama ? ` - ${bk.aciklama}` : ""}
            </MenuItem>
          ))}
        </TextField>


        <TextField
          fullWidth
          label="Özel Kod"
          value={form.ozelKod}
          onChange={(e) => setForm({ ...form, ozelKod: e.target.value })}
        />

        {editMode && bakiyeliHesap && (
          <Box
            sx={{
              textAlign: "center",
              color: "#c62828",
              fontSize: "13px",
              fontWeight: 600,
              mt: 1,
              mb: 1,
            }}
          >
            Bakiyeli hesap silinemez
          </Box>
        )}

      </ProsetPopup>

      <SilmeUyariPopup
        open={silmePopupOpen}
        message={silmeMesaji}
        onCancel={() => setSilmePopupOpen(false)}
        onConfirm={handleDeleteConfirmed}
      />

    </div>
  );
};

export default KuyumcuHesaplarPage;
